export default "__VITE_ASSET__DBvvhaEZ__"